import { Outlet, NavLink } from "react-router-dom";
import { Home, FileText, DollarSign, MessageSquare, UserCircle } from "lucide-react";
import { NotificationBell } from "@/components/notifications";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { SignOutButton } from "@/components/layout/SignOutButton";

const navigation = [
  { name: { en: "Dashboard", fr: "Tableau de bord" }, href: "/dashboard/deal-sourcer", icon: Home, end: true },
  { name: { en: "My Submissions", fr: "Mes soumissions" }, href: "/dashboard/deal-sourcer/submissions", icon: FileText },
  { name: { en: "Commissions", fr: "Commissions" }, href: "/dashboard/deal-sourcer/commissions", icon: DollarSign },
  { name: { en: "Messages", fr: "Messages" }, href: "/dashboard/deal-sourcer/messages", icon: MessageSquare },
  { name: { en: "Profile", fr: "Profil" }, href: "/dashboard/deal-sourcer/profile", icon: UserCircle },
];

export default function DealSourcerLayout() {
  const { language } = useLanguage();
  const lang = (language as "en" | "fr") || "en";

  return (
    <div className="min-h-screen bg-background flex">
      <aside className="w-64 border-r bg-[#1D314D] text-white flex flex-col">
        <div className="h-16 flex items-center px-6 border-b border-white/10">
          <img src="/noBgColor.png" alt="AcquizGroup" className="h-8" />
        </div>
        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {navigation.map((item) => (
            <NavLink
              key={item.href}
              to={item.href}
              end={item.end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#CEAB65] text-[#1D314D]"
                    : "text-white/80 hover:bg-white/10 hover:text-white"
                }`
              }
            >
              <item.icon className="w-5 h-5" />
              <span>{item.name[lang]}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      <div className="flex-1 flex flex-col">
        <header className="h-16 border-b bg-card px-6 flex items-center justify-between">
          <h1 className="text-xl font-semibold text-[#1D314D]">
            {lang === "fr" ? "Portail Deal Sourcer" : "Deal Sourcer Portal"}
          </h1>
          <div className="flex items-center gap-3">
            <NavLink to="/dashboard/deal-sourcer/profile">
              <Button variant="ghost" size="sm" className="gap-2">
                <UserCircle className="h-4 w-4" />
                {lang === "fr" ? "Profil" : "Profile"}
              </Button>
            </NavLink>
            <NotificationBell />
            <SignOutButton />
          </div>
        </header>

        <main className="flex-1 p-6 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
